import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter} from "react-router-dom";
import '@fontsource/poppins'
import '@fontsource/lora'
import { Provider } from "react-redux";
import store from "./Redux/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import * as Sentry from "@sentry/react";
import { AppSettings } from "./Utils/Settings";

Sentry.init({
  dsn: AppSettings.Sentry.Dsn,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "app.kazikonekt.com"],
  // Session Replay
  replaysSessionSampleRate: AppSettings.Sentry.SessionSampleRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: AppSettings.Sentry.ErrorsSampleRate, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// @ts-ignore
// We will always have a root so this check can be ignored (Babs)
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <App />
          </LocalizationProvider>
        </BrowserRouter>
      </Provider>
  </React.StrictMode>
);